// Indexing
export const BASEMENT = "BASEMENT";
export const ROOF_HOSTED = "ROOF HOSTED";
export const FLOOR_EXT = "FLOOR";
export const FLOOR_EXT_SHORT = "FLR";

type LevelNameBase = "FIRST" | "SECOND" | "THIRD" | "FOURTH" | "FIFTH";

export type LevelName = `${LevelNameBase} ${typeof FLOOR_EXT}` | typeof BASEMENT;
export type LevelNameShort = `${LevelNameBase} ${typeof FLOOR_EXT_SHORT}` | typeof BASEMENT;

export const ITEM_INDEX: { [itemIndex: number]: LevelNameBase } = {
  0: "FIRST",
  1: "SECOND",
  2: "THIRD",
  3: "FOURTH",
  4: "FIFTH",
};
